<a *ngIf="!editState" (click)='editItem($event, offer)' class="fa fa-plus-circle fa-lg" href="javascript:;"><span>{{ 'ADD-OFFER' | translate }}</span></a>
<a *ngIf="editState" (click)='editItem($event, offer)' class="close right-long-arrow" href="javascript:;"><span></span>
    <!-- <div>לכל
    ההצעות</div> -->
</a>
<mat-dialog-content class="mat-typography composite-design">
    <div class="add-offer-holder" *ngIf="!editState">
        <ul class="offer-list">
            <li *ngFor="let offer of offers">
                <div class="header-holder">
                    <a (click)='deleteItem($event, offer)' href='javascript:;' class="fa fa-trash fa-lg col m4"></a>
                    <a (click)="goToOffer(offer)" href="javascript:;" class="title">
                        <span>{{ 'OFFER-TO' | translate }}</span>
                        <h1>{{ offer.client.name }}</h1>
                    </a>
                    <a class="send-offer-button" mat-stroked-button color="primary"
                        href="https://api.whatsapp.com/send?text={{ this.routeNavigate + '/company/u/' + this.proj.parrentId + '/' + this.proj.uid + '/offers/' + offer.uid + '?m=all' + '&phone='+ offer.client.areaCode + offer.client.phone }}"
                        target="_blank">{{ 'SEND-OFFER-WHATSAPP' | translate }}</a>
                </div>
                <div class="offer-details">
                    <p class="title">{{ 'OFFER-DETAILS' | translate }}</p>
                    <!-- <p *ngIf="this.offer.connect">מחובר עכשיו: {{ offer.connect.now }} </p> -->
                    <ul>
                        <li>{{ 'NOT-SHOWN-TEXT' | translate }}: {{ offer.freeText }}</li>
                        <li>{{ 'PRICE' | translate }}: {{ offer.price }}</li>
                        <li>
                            <div *ngIf="this.offer.connect">{{ offer.connect.date | date:'dd'}}.{{offer.connect.date |
                                date:'MM'}}.{{offer.connect.date | date:'yy'}}</div>
                        </li>
                    </ul>
                </div>
                <div class="client-details">
                    <p *ngIf="offer.client" class="title">{{ 'client details' | translate }}</p>
                    <ul *ngIf="offer.client">
                        <li>{{ offer.client.name }}</li>
                        <li>{{ offer.client.areaCode }}{{ offer.client.phone }}</li>
                        <li>{{ offer.client.email }}</li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <div *ngIf="editState && itemToEdit.id == offer.id" class="edit">
        <a class="close-section" href="javascript:;" (click)='closeEdit()'></a>
        <h5>{{ 'NEW-OFFER' | translate }}</h5>
        <form (ngSubmit)=onSubmit() name="addOffer" [formGroup]="addOffer" #newMarker="ngForm">
            <mat-form-field>
                <mat-label>{{ 'NAME' | translate }}:</mat-label>
                <input [(ngModel)]='offer.client.name' matInput placeholder="{{ 'NAME' | translate }}" name="name"
                    formControlName="name" required>
                <!-- <mat-error *ngIf="this.addOffer.value.name">{{getErrorMessage()}}</mat-error> -->
            </mat-form-field>
            <div class="phone-holder">
                <!-- <mat-label class="label-phone">{{ 'PHONE' | translate }}:*</mat-label> -->
                <mat-form-field class="area" class="area-code">
                    <select class="area-code" [(ngModel)]='offer.client.areaCode' matNativeControl required
                        (change)="onChangeAreaCode($event.value)" name="areaCode" formControlName="areaCode"
                        class="area-code-select">
                        <option type="number" *ngFor="let code of areaCodes" value="{{ code }}">{{ code }}
                        </option>
                    </select>
                </mat-form-field>
                <mat-form-field class="phone">
                    <input [(ngModel)]='offer.client.phone' #phoneNumber matInput placeholder="{{ 'PHONE' | translate }}" name="phone"
                        formControlName="phone" required>
                    <!-- <mat-error *ngIf="this.addOffer.value.phone.invalid">{{getErrorMessage()}}</mat-error> -->
                </mat-form-field>
            </div>
            <mat-form-field>
                <mat-label>{{ 'EMAIL' | translate }}:</mat-label>
                <input [(ngModel)]='offer.client.email' matInput placeholder="{{ 'EMAIL' | translate }}" name="email"
                    formControlName="email">
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'NOT-SHOWN-TEXT' | translate }}:</mat-label>
                <input [(ngModel)]='offer.freeText' matInput placeholder="{{ 'FREE-TEXT' | translate }}" name="freeText"
                    formControlName="freetext">
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'PRICE' | translate }}:</mat-label>
                <input [(ngModel)]='offer.price' matInput placeholder="{{ 'PRICE' | translate }}" name="price" formControlName="price">
            </mat-form-field>
            <input type="submit" value="{{ 'SEND' | translate }}" class="btn" [disabled]="addOffer.invalid">
        </form>
    </div>

</mat-dialog-content>